exports.decodePowerUnit = (powerunit) => {
  const powerUnitHex = new Buffer.from(powerunit, "hex");
  return {
    Ladespannung: `${powerUnitHex[2]} V`,
    Akkuspannung: `${powerUnitHex[0]} V`,
    Innenwiderstand: `${powerUnitHex[5]} mΩ`,
  };
};
